import Button from "@/common/components/Button";
import GoBackButton from "@/common/components/GoBackButton";
import ReasonModal from "@/common/components/ReasonModal";
import { useGoBack } from "@/common/hooks/useGoBack"
import { useArchivePrivateCompanyLead } from "@/features/privateCompanyLeadsFunnel/hooks/useArchivePrivateCompanyLead"
import { useIsMutating, useQueryClient } from "@tanstack/react-query"
import { useState } from "react";

interface LeadHeaderProps {
  privateCompanyLeadId: string
  display_name?: string
  url?: string
  showArchiveButton?: boolean
  archived_at?: string
  buttons?: JSX.Element
}

export const LeadHeader = ({
  privateCompanyLeadId,
  display_name,
  url,
  showArchiveButton,
  archived_at,
  buttons,
}: LeadHeaderProps) => {
  const goBack = useGoBack()
  const queryClient = useQueryClient()
  const isMutating = !!useIsMutating()

  const [showReasonModal, setShowReasonModal] = useState(false);

  const archiveUnarchiveOperationKlass = archived_at ? 'Admin::Funnel::PrivateCompanyLeads::Unarchive' : 'Admin::Funnel::PrivateCompanyLeads::Archive'

  const {
    mutate: archivePrivateCompanyLead,
    isError: archivePrivateCompanyLeadIsError,
  } = useArchivePrivateCompanyLead({
    privateCompanyLeadId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privateCompanyLead', privateCompanyLeadId] })
      goBack({ fallback: '/private-clients', searchLastRouteFromFallback: true })
    },
  })

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback='/private-clients' searchLastRouteIgnoringFilters />
          {url ? (
            <img
              src={url}
              alt={display_name}
              className="size-10 rounded-full object-cover"
            />
          ) : (
            <div className="size-10 bg-white-800 rounded-full"></div>
          )}
          <p data-testid="lead_header_display_name" className="text-white-400 font-normal">{display_name}</p>
          {showArchiveButton && (
            <Button
              type="button"
              variant="outline-error"
              operationKlassToCheckPermission={archiveUnarchiveOperationKlass}
              onClick={() => setShowReasonModal(true)}
              disabled={isMutating}
            >
              {archived_at ? 'Desarquivar' : 'Arquivar'}
            </Button>
          )}
        </div>
        {buttons}
      </div>
      {archivePrivateCompanyLeadIsError && (
        <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>
      )}
      <ReasonModal
        isOpen={showReasonModal}
        setIsOpen={setShowReasonModal}
        onSubmit={(reasonData) => archivePrivateCompanyLead({
          log_reason: reasonData, 
          newStatus: archived_at ? 'unarchive' : 'archive'
        })}
      />
    </div>
  )
}
